import { FC } from "react"

import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

import { Price } from "../SendStoreChargeDialog.parts"
import { roundToCents } from "../SendStoreChargeDialog.utils"

interface IProps {
  costPerStudent: number
  predictedChargedCount: number
}

const ReviewTotals: FC<IProps> = ({
  costPerStudent,
  predictedChargedCount,
}) => {
  const { t } = useTranslation()

  // Two-column grid hugging the right edge: labels and amounts each share a left edge.
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "auto auto",
        justifyContent: "end",
        alignItems: "center",
        columnGap: 2,
        rowGap: 1.5,
        // Rows use `display: contents` so their cells join the grid.
        "& > *": { display: "contents" },
      }}
    >
      <Box>
        <Typography variant="body2" fontWeight={500} color="mockup.neutral10">
          {t("storeCharge.review.totalPerStudent")}
        </Typography>
        <Price amount={costPerStudent} fontSize={20} />
      </Box>
      <Box>
        <Typography variant="body2" fontWeight={500} color="mockup.neutral10">
          {t("storeCharge.review.totalAcross", {
            count: predictedChargedCount,
          })}
        </Typography>
        <Price
          amount={roundToCents(costPerStudent * predictedChargedCount)}
          fontSize={26}
        />
      </Box>
    </Box>
  )
}

export default ReviewTotals
